import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import TeamsReport from "./components/teams";
import LearningsReport from "./components/learnings";
import moment from "moment";
import { Filters } from "./components/filter";
import Actions from "src/components/actionbar";
import { CourseReportContext, CourseReportContextProps } from "./context";
import SelectedFilters from "./components/selectedFilters";

import _ from "lodash";
import cx from "classnames";
import styles from "./reports.module.scss";

import userRoleService from "src/utils/userRoles.service";
import PermissionDenined from "src/components/permissionDenied";

const CoachingReports: React.FC<object> = () => {
  const user = useSelector((state: any) => _.get(state, "users.me.id", null));

  const [activeTab, setActiveTab] = useState(0);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [teamsReportContext, setTeamsReportContext] = useState<CourseReportContextProps>({
    user: null,
    userGroups: null,
    skills: null,
    startDate: moment().subtract(30, "days").startOf("day").toDate(),
    endDate: moment().endOf("day").toDate(),
  });
  
  const [learningsReportContext, setLearningsReportContext] = useState<CourseReportContextProps>({
    user: null,
    userGroups: null,
    skills: null,
    startDate: moment().subtract(30, "days").startOf("day").toDate(),
    endDate: moment().endOf("day").toDate(),
  });

  const activeReportContext = activeTab === 0 ? teamsReportContext : learningsReportContext;
  const setActiveReportContext = activeTab === 0 ? setTeamsReportContext : setLearningsReportContext;

  const toggleFilterDialog = () => {
    setShowFilterDialog(!showFilterDialog);
  };

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const handleConfirm = (state) => {
    if (activeTab === 0) {
      setTeamsReportContext({
        user: state.user,
        userGroups: state.userGroups,
        skills: state.skills,
        startDate: moment(state.startDate).startOf('day').toDate(),
        endDate: moment(state.endDate).endOf('day').toDate(),
      });
    } else {
      setLearningsReportContext({
        user: state.user,
        userGroups: null,
        skills: state.skills,
        startDate: moment(state.startDate).startOf('day').toDate(),
        endDate: moment(state.endDate).endOf('day').toDate(),
      });
    }
    setShowFilterDialog(false);
  };

  React.useEffect(() => {
    if (!userRoleService.canAccessCoachingReport() && activeTab === 0) {
      setActiveTab(1);
    }
  }, []);

  const handleRemoveSkill = (skillId: string) => {
    const skills = activeReportContext.skills?.filter((s) => s.id !== skillId) || [];
    setActiveReportContext((prev) => ({
      ...prev,
      skills,
    }));
  };

  const handleRemoveGroup = (groupId: string) => {
   const userGroups = activeReportContext.userGroups?.filter((g) => g.id !== groupId) || [];
   setActiveReportContext((prev) => ({
      ...prev,
      userGroups,
    }));
  };

  const filterCount =  _.size(activeReportContext.skills) + _.size(activeReportContext.userGroups) + 1 
  const title = filterCount > 0 ?  `Filter ${filterCount}` : "Filters";

  return (
    <div className={styles.container}>
      <div className={styles.tabsContainer}>
        <div
          className={cx(styles.tabs, {
            [styles.active]: activeTab,
          })}
        >
          {userRoleService.canAccessCoachingReport() && (
            <div
              className={cx(styles.tab, { [styles.active]: activeTab == 0 })}
              onClick={() => handleTabClick(0)}
            >
              teams
            </div>
          )}

          <div
            className={cx(styles.tab, { [styles.active]: activeTab == 1 })}
            onClick={() => handleTabClick(1)}
          >
            learnings
          </div>

          <SelectedFilters
            reportContext={activeReportContext}
            onRemoveSkill={handleRemoveSkill}
            onRemoveGroup={handleRemoveGroup}
          />
        </div>

        <Actions.Button
          icon={"paperflite-settings"}
          className={styles.filterButton}
          onClick={toggleFilterDialog}
          title={title}
        />
      </div>
      <CourseReportContext.Provider value={activeReportContext}>
      {activeTab === 0 && <TeamsReport />}
      {activeTab === 1 && <LearningsReport />}
      <Filters
        show={showFilterDialog}
        onClose={toggleFilterDialog}
        onConfirm={handleConfirm}
        showUserGroups={activeTab === 0}
      />
    </CourseReportContext.Provider>
    </div>
  );
};

export { CoachingReports };
